module.exports = __webpack_public_path__ + "img/diy2.4c1de55e.png";